














































































































































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { mapGetters } from 'vuex';
// import lodash from 'lodash';
import UserProfileMenu from '@/components/Users/UserProfileMenu.vue';
import { AgencyModule } from '@/store/modules/agency';
import NavigationScope from '@/models/Shared/NavigationScope'
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';
import { MessagingModule } from '@/store/modules/messaging';

@Component({
  name: 'LoggedInNonScrollyLayout',
  components: { UserProfileMenu }
})
export default class extends GiganautVue {

  searchDrawer: false;
  public searchText: null;
  public company: null; 

  openHelpDesk() {
    // SysAdmin users navigate to Knowledge Base
    // Agency users still go to Freshdesk
    if (this.userType === 'SysAdmin') {
      this.$router.push({ name: PageNames.AgencyKnowledgeBase });
    } else {
      window.open("https://giganaut.freshdesk.com");
    }
  }

  get isSysAdminScope() {
    return AppModule.navigationMenu.scope;
  }

  get sysAdminMenuItems() {
    return AppModule.navigationMenu.sysAdminMenuItems;
  }

  get agencyMenuItems() {
    return AppModule.navigationMenu.agencyMenuItems;
  }

  get isAgencyVisibleAndClickable() {
    return (AppModule.navigationMenu.scope === NavigationScope.Agency || AppModule.navigationMenu.scope === NavigationScope.Company) && (AppModule.userProfile.userType === "Agency" || AppModule.userProfile.userType === "SysAdmin")
  }

  get isAgencyVisibleAndNotClickable() {
    return (AppModule.navigationMenu.scope === NavigationScope.Agency || AppModule.navigationMenu.scope === NavigationScope.Company) && (AppModule.userProfile.userType === "Company")
  }

  get isCompanyScope() {
    return AppModule.navigationMenu.scope === NavigationScope.Company;
  }
  
  get agencyName() {
    let agencyName = AppModule.currentAgencyContext.brandName;
    if (window.location.hostname === "dev-portal.giganaut.com") {
      agencyName = agencyName + " (Development Environment)"
    }
    if (window.location.hostname === "localhost") {
      agencyName = agencyName + " (Local Environment)"
    }
    return agencyName;
  }

  get agencyTotalActionRequiredConversationsCount() {
    return MessagingModule.totalActionRequiredConversationsCount;
  }

  get userType() {
    if (AppModule.userProfile == null) {
      return "";
    }
    return AppModule.userProfile.userType;
  }

  get toolbarColor() {
    if (this.userType === "SysAdmin" && window.location.hostname === "portal.giganaut.com") {
      return "red";
    }
    if (window.location.hostname === "dev-portal.giganaut.com") {
      return "#ff6200";
    }
    if (window.location.hostname === "localhost") {
      return "green";
    }
    return "primary";
  }

  get companyMenuItems() {
    return AppModule.navigationMenu.companyMenuItems;
  }

   get companyName() {
    return CompanyDetailsModule.currentCompany.brandName;
  }

  get navigationDrawerIsMini() {
    return AppModule.navigationDrawerIsMini;
  }

  setNavigationDrawerIsMini(navigationDrawerIsMini: boolean) {
    AppModule.setNavigationDrawerIsMini(navigationDrawerIsMini);
  }

  async agencyScopeClick() {
    await AppModule.getAgencyContext(AppModule.currentAgencyContext.id)
    await AppModule.getUserProfile()
    this.$router.push({ name: PageNames.AgencyBookings});
  }

  async clearAgencyContextClick() {
    this.$router.push({ name: PageNames.SysAdminAgencies});
  }
  
  // set drawer(value: boolean) {
  //   AppModule.setDrawer(value);
  // }

  // get drawer() {
  //   return this.drawer;
  // }

  // props: {
  //   source: String,
  // },
  // data: () => ({
  //   drawer: null,
  //   SearchDrawer: null,
  //   searchText: null,
  //   company: null,
  // }),
  // mounted() {
  //   // this.focusInput();
  // },
  // computed: {
  //   ...mapGetters([
  //     'companiesSearch',
  //   ]),
  // },
  // methods: {
  //   focusInput() {
  //     // this.$refs.searchBox.focus();
  //   },
  //   // eslint-disable-next-line
  //   // searchDebounce: lodash.debounce(function (Any: searchValue) {
  //   //   this.search(searchValue);
  //   // }, 500),
  //   // search(searchValue) {
  //   //   this.$store.dispatch('SEARCH_COMPANY', searchValue);
  //   // },
  //   // navigateToCompany(company) {
  //   //   const companyId = company.id;
  //   //   this.$router.push({ name: 'company Details', params: { id: companyId } });
  //   // },
  // },
  // watch: {
  //   // searchText(value) {
  //   //   if (!value) {
  //   //     this.$store.dispatch('CLEAR_SEARCH');
  //   //   } else {
  //   //     this.searchDebounce(value);
  //   //   }
  //   // },
  // },
}
